/**
 * @generated SignedSource<<6b78b14408b036fd22404f912d2e11d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBuyerIncentivesCompact_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDibsPromiseModalLazy_user">;
  readonly " $fragmentType": "PdpSharedBuyerIncentivesCompact_user";
};
export type PdpSharedBuyerIncentivesCompact_user$key = {
  readonly " $data"?: PdpSharedBuyerIncentivesCompact_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyerIncentivesCompact_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBuyerIncentivesCompact_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDibsPromiseModalLazy_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3cad327c8c8cd567f56e7d64c4b9cae1";

export default node;
